import { useState, useEffect } from 'react';
import { Button, Text, useTheme, Grid } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

import { COMMUNITY_GUIDELINES_ACCEPTED } from './constants';
import { NoticeSection } from './styled';
import { usePersistentStorage } from '@/hooks/useCoupon';

interface Props {
  openCommunityGuidelines: () => void;
}

const GuidelinesNotice = ({ openCommunityGuidelines }: Props) => {
  const [accepted, setAccepted] = useState(true);

  const { get } = usePersistentStorage();
  useEffect(() => {
    const getAccepted = async () => {
      const isAccepted = await get(COMMUNITY_GUIDELINES_ACCEPTED);
      setAccepted(isAccepted === 'true');
    };
    getAccepted();
  }, [get]);
  const theme = useTheme();

  if (accepted) {
    return null;
  }

  return (
    <NoticeSection
      templateColumns="auto auto"
      gap={`${theme.x1spacePx}px`}
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid
        templateColumns="auto auto"
        gap={`${theme.x1spacePx}px`}
        justifyContent="start"
        alignItems="center"
      >
        <InformationSolid fill={theme.color.whiteRGBA(0.5)} />
        <Text typography="small" color="whiteRGBA" opacity={0.8}>
          Make sure you read the community guidelines before commenting
          <Button
            marginLeft
            styleType="strongLink"
            display="inline"
            onClick={openCommunityGuidelines}
          >
            Community Guidelines
          </Button>
        </Text>
      </Grid>
      <Button styleType="passive" onClick={() => setAccepted(true)}>
        <CrossSolid fill={theme.color.white} opacity="0.5" />
      </Button>
    </NoticeSection>
  );
};

export default GuidelinesNotice;
